var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext } from 'react';
import StateContext from '../../context/state-context';
import { StyledText } from '../LabelValue/LabelValue';
export default function StateValue(props) {
    var _a, _b;
    var content = useContext(StateContext);
    return React.createElement(StyledText, __assign({}, props), (_b = (_a = content[props.contentKey]) !== null && _a !== void 0 ? _a : props.defaultValue) !== null && _b !== void 0 ? _b : '');
}
//# sourceMappingURL=StateValue.js.map